import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { FuseConfigService } from '@fuse/services/config.service';
import { fuseAnimations } from '@fuse/animations';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../../shared/common/helper/http-service';
import { Configuration } from 'app/app.configuration';
import { SocketService } from 'app/shared/common/helper/socket.service';

@Component({
    selector: 'forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})

export class ForgotPasswordComponent implements OnInit {

    forgotPasswordForm: FormGroup;

    /**
     * Constructor
     *
     * @param {FuseConfigService} _fuseConfigService
     * @param {FormBuilder} _formBuilder
     */
    constructor(
        private _fuseConfigService: FuseConfigService,
        private _formBuilder: FormBuilder,
        private parseService: ParseService,
        private toastr: ToastrService,
        private router: Router,
        private http: HttpClient,
        private dataService: DataService,
        private configuration: Configuration,
        private _socket: SocketService
    ) {
        // Configure the layout
        this._fuseConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };

    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        const emailRegEx = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';
        this.forgotPasswordForm = this._formBuilder.group({
            email: ['', [Validators.required, Validators.email, Validators.pattern(emailRegEx)]]
        });
    }

    async forgotPassword() {
        let user = this.parseService.instance.Object.extend('_User');
        let query = new this.parseService.instance.Query(user);
        query.equalTo('email', this.forgotPasswordForm.value.email);
        query.include('profile');
        query.find().then(async res => {
            let result = res[0];
            if (res.length > 0) {

                let startend = this.startenddates(new Date());

                let UserTimeSheet = this.parseService.instance.Object.extend('UserTimeSheet');
                let userTimeSheet = new this.parseService.instance.Query(UserTimeSheet);
                userTimeSheet.equalTo('user', { __type: 'Pointer', className: '_User', objectId: result.id });
                userTimeSheet.greaterThan('createdAt', startend[0]);
                userTimeSheet.lessThan('createdAt', startend[1]);
                let timeSheetDetails = await userTimeSheet.find();
                for (let data of timeSheetDetails) {
                    if (data.get('currentStatus') == 'work' || data.get('currentStatus') == 'idle') {
                        return this.toastr.warning('Please close the Desktop application!!')
                        // data.set('currentStatus', 'logout');
                        // data.save();
                        // let sendSocket = { event_type: 'FORGOT_PASSWORD_DESKTOP_LOGOUT' }
                        // this._socket.sendSocketEvent('SOCKET_EMIT_EVENT', sendSocket);
                    }
                }

                let password = this.generatePassword();

                result.set('password', password);
                result.save({}, { useMasterKey: true });
                this.toastr.success('Password Reset Email Sent.');
                this.router.navigate(['/login']);

                let data = {
                    name: result.get('firstName') + ' ' + result.get('lastName'),
                    email: this.forgotPasswordForm.value.email,
                    password: password
                }

                this.dataService.add(this.configuration.forgotPassword, data).subscribe((data: any) => {
                });
            }
            if (res.length == 0) {
                this.toastr.error('Email Id does not Exist.');
            }
        });
    }

    generatePassword() {
        var length = 8,
            charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789",
            retVal = "";
        for (var i = 0, n = charset.length; i < length; ++i) {
            retVal += charset.charAt(Math.floor(Math.random() * n));
        }
        return retVal;
    }

    dayafter(d) {
        let day = new Date(d);
        return new Date(day.setDate(day.getDate() + 1));
    }

    daybefore(d) {
        let day = new Date(d);
        return new Date(day.setDate(day.getDate() - 1));
    }

    startenddates(day) {
        let startdate = this.daybefore(new Date(day));
        startdate.setHours(23, 59, 59, 999);
        let enddate = this.dayafter(day);
        enddate.setHours(0, 0, 0, 0);
        return [startdate, enddate];
    }

}
